/* eslint-disable react/no-deprecated */
import React from "react";
import { connect } from "react-redux";
import commonActions from "action-creators/common";
import { matchRoutes, renderRoutes } from "react-router-config";
import { checkPermissionsOfRoute } from "configs/Roles";
import endpoints from "configs/endpoints";
import userActions from "action-creators/user";
import queryString from "query-string";
import Request from "../common/network/http/Request";
import { history } from "../store";
import LayoutRegister from "./register";
import "./layout-common.scss";
import "antd/dist/antd.less";
import AuditAction from "reducers/AuditRedux";
import { parseTenantFromURL } from "../utils";
import env from "environment";

const redirects = {
  "/": "/app",
  "/contact-us": "/app/contact-us",
  "/my-account/farms": "/app/my-account/farms",
  "/my-account/listing": "/app/my-account/listings",
  "/my-account/listing/all": "/app/my-account/listings",
  "/my-account/listing/active": "/app/my-account/listings",
  "/my-account/listing/upcoming": "/app/my-account/listings",
  "/my-account/listing/pending_confirmation": "/app/my-account/listings",
  "/my-account/listing/lease_pending": "/app/my-account/listings",
  "/my-account/listing/expired": "/app/my-account/listings",
  "/my-account/listing/inquiry": "/app/my-account/cashrentstimates",
  "/my-account/listing/leased": "/app/my-account/leases",
  "/my-account/settings": "/app/my-account/settings/account-information",
  "/my-account/payments": "/app/my-account/payments",
  "/my-account/bidding": "/app/my-account/bidding/my-bid",
  "/my-account/bidding/my-bid": "/app/my-account/bidding/my-bid",
  "/my-account/bidding/my-agreements": "/app/my-account/bidding/my-agreements-list",
  "/my-account/settings/notifications": "/app/my-account/settings/notifications",
  "/my-account/settings/farmer-profile": "/app/my-account/settings/farmer-profile",
};

/**
 * Created by vntopmas@gmail.com
 * Email: vntopmas@gmail.com
 **/
class Layouts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      width: 0,
      height: 0,
      router: {},
    };
  }

  componentDidMount = async () => {
    const { dispatch, user, isImpersonating } = this.props;

    const referralCode = queryString.parse(this.props.location.search).referral_code;
    dispatch(commonActions.setReferralCode(referralCode));

    await this.handleOnChangeLayout();

    if (user.id && !isImpersonating) {
      const res = await Request.get(endpoints.user.getMe);
      if (res.status === 200) {
        dispatch(userActions.setUser(res.data));
        dispatch(AuditAction.fetchAuditData(res.data));
      }
    }
  }

  componentWillReceiveProps =async (nextProps) => {
    if (this.props.location.pathname !== nextProps.location.pathname) {
      await this.handleOnChangeLayout(nextProps);
    }
  }

  componentWillUnmount() {
    window.messagePopup = undefined;
    window.removeEventListener("resize", this.updateWindowDimensions);
  }


  handleOnChangeLayout =async (nextProps) => {
    const { dispatch, location, route, loginedInfo, user } = nextProps || this.props;
    if (!location) {
      return;
    }

    const branches = matchRoutes(route.routes, location.pathname);
    if (!branches || branches.length === 0) {
      return;
    }

    if (redirects[location.pathname]) {
      let subdomain = "";
      const tenant = parseTenantFromURL(window.location.host);

      if (tenant !== window.location.host) {
        subdomain = `${tenant}.`;
      }

      return window.location.assign(`https://${subdomain}${env.REACT_APP_CG_STANDALONE_DOMAIN}${redirects[location.pathname]}`);
    }

    const branchRoute = branches[0].route;
    if (branchRoute && branchRoute.layout && (!this.state.layoutId || branchRoute.layout !== this.state.layoutId)) {
      const layoutId = branchRoute.layout;
      this.setState({ layoutId });
    }

    for (let i = 0; i < branches.length; i++) {
      if (!checkPermissionsOfRoute(branches[i], dispatch, history, loginedInfo, user)) {
        return;
      }
    }
  }

  render() {
    const { route } = this.props;
    const { layoutId } = this.state;

    if (!layoutId) {
      return (<div>Site not found</div>);
    }

    const CurrentLayoutConfig = LayoutRegister[layoutId];
    return (
      <div className="ui-root-layout">
        <CurrentLayoutConfig.component onLayoutChange={this.handleOnChangeLayout}>
          {renderRoutes(route.routes)}
        </CurrentLayoutConfig.component>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  currentLayout: state.layout,
  user: state.user.user,
  loginedInfo: state.user,
  isImpersonating: !!state.auth.impersonationTarget,
});

export default connect(mapStateToProps)(Layouts);
